'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import cx from 'classnames';
import { CatHeader } from '@blocks-react/components/Header';
import { useInAppSignOut } from '../../hooks/useInAppSignOut';
import styles from './Header.module.scss';
export const HeaderContainer = ({ children, id, className, isStickyHeaderEnabled, isLoggedIn = false }) => {
    const { setInAppCookie } = useInAppSignOut();
    useEffect(() => {
        if (isLoggedIn) {
            setInAppCookie(isLoggedIn);
        }
    }, [isLoggedIn, setInAppCookie]);
    return (_jsx(CatHeader, { id: `${cx(id)}`, className: `${cx(className)} ${isStickyHeaderEnabled ? styles['header--sticky'] : ''} ${styles['header--fallback']} `, children: _jsx("div", { className: "w-100 d-print-none", children: children }) }));
};
